"use client";

import { useContext } from "react";

import { SessionContext, useSessionContext } from "@/components/session/SessionProvider";

export function useSession() {
  return useSessionContext();
}

export function useOptionalSession() {
  return useContext(SessionContext);
}
